import { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import Icon from '../../Icons'

class UserClassStoryPast extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nextMonthBlocked: true,
    }
    this.getPastEvents = this.getPastEvents.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const { startDate } = nextProps.archive
    if (moment().isSame(startDate, 'month') || moment().isBefore(startDate, 'month')) {
      this.setState({ nextMonthBlocked: true })
    }
  }

  getPastEvents(e, currentDate, isPrev) {
    e.preventDefault()
    const { fetchPastEvents } = this.props
    if (isPrev) {
      const start = moment(currentDate).subtract(1, 'months').startOf('month').valueOf()
      const end = moment(currentDate).subtract(1, 'months').endOf('month').valueOf()
      fetchPastEvents(start, end)
      this.setState({ nextMonthBlocked: false })
    } else if (!this.state.nextMonthBlocked) {
      const start = moment(currentDate).add(1, 'months').startOf('month').valueOf()
      const end = moment(currentDate).add(1, 'months').endOf('month').valueOf()
      fetchPastEvents(start, end)
    }
  }

  render() {
    const { t } = this.props
    const { classes, startDate } = this.props.archive
    const currentDate = startDate
    const navLabel = moment(startDate).format('MMMM YYYY')
    return (
      <div className="ctp-userclass-past">
        <div className="rbc-toolbar ctp-toolbar">
          <nav className="ctp-toolbar__navigation">
            <button
              type="button"
              className="ctp-toolbar__arrow"
              onClick={(e) => this.getPastEvents(e, currentDate, true)}
            >
              <span>
                <Icon icon="arrow" />
              </span>
            </button>
            <button
              type="button"
              className={`ctp-toolbar__arrow ${this.state.nextMonthBlocked ? 'is-disabled' : ''}`}
              onClick={(e) => this.getPastEvents(e, currentDate, false)}
            >
              <span>
                <Icon icon="arrow" />
              </span>
            </button>
            <span className="rbc-toolbar-label">{navLabel}</span>
          </nav>
        </div>
        {classes.length === 0 && (
          <small className="ctp-userclass-past__not-found">
            {t('user-panel:classes.noArchiveEvents')}
          </small>
        )}
        {classes.length > 0 && (
          <ul>
            {classes.map((item) => {
              return (
                <li key={item.id}>
                  <data>{moment(item.date).format('DD MMM YYYY')}</data>
                  <small>{item.name}</small>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    )
  }
}

UserClassStoryPast.propTypes = {
  archive: PropTypes.object,
  fetchPastEvents: PropTypes.func,
  t: PropTypes.func,
}

export default withTranslation(['user-panel'])(UserClassStoryPast)
